// Server-Sent Events parsing for Artemis streams (WEB-7092).
// Follows the WHATWG event-stream rules: lines end in \n, \r\n or \r; "data" fields
// accumulate joined by \n; a blank line dispatches the event; lines starting with ":"
// are comments. EventSource can't send a bearer header, so we read fetch bodies instead.

export const createSseParser = onEvent => {
    let buffer = ''
    let data = []
    let eventName = ''
    let lastEventId = null
    // A chunk can end between the \r and \n of one line ending.
    let skipLeadingLf = false

    const dispatch = () => {
        if (data.length > 0) {
            onEvent({ event: eventName || 'message', data: data.join('\n'), id: lastEventId })
        }
        data = []
        eventName = ''
    }

    const processLine = line => {
        if (line === '') return dispatch()
        if (line.startsWith(':')) return

        const colon = line.indexOf(':')
        const field = colon === -1 ? line : line.slice(0, colon)
        let value = colon === -1 ? '' : line.slice(colon + 1)
        if (value.startsWith(' ')) value = value.slice(1)

        if (field === 'data') data.push(value)
        else if (field === 'event') eventName = value
        else if (field === 'id' && !value.includes('\0')) lastEventId = value
    }

    return {
        feed(chunk) {
            buffer += chunk
            if (skipLeadingLf && buffer.startsWith('\n')) buffer = buffer.slice(1)
            skipLeadingLf = false

            let start = 0
            for (let i = 0; i < buffer.length; i++) {
                const ch = buffer[i]
                if (ch !== '\n' && ch !== '\r') continue
                processLine(buffer.slice(start, i))
                if (ch === '\r') {
                    if (i + 1 === buffer.length) skipLeadingLf = true
                    else if (buffer[i + 1] === '\n') i++
                }
                start = i + 1
            }
            buffer = buffer.slice(start)
        },

        // The stream closed. Dispatch a last event that wasn't followed by a blank line,
        // which is more forgiving than the spec but loses nothing a server meant to send.
        end() {
            if (buffer !== '') processLine(buffer)
            buffer = ''
            dispatch()
        },

        get lastEventId() {
            return lastEventId
        }
    }
}
